import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container, Box, Typography, Button, CircularProgress, Alert, Card, CardContent,
} from '@mui/material';
import { ArrowBack, Send } from '@mui/icons-material';
import ProfileCard from '../../components/profile/ProfileCard';
import ScoutForm from '../../components/scout/ScoutForm';
import { companyService } from '../../services/companyService';

const ProfileDetailPage: React.FC = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [data, setData] = useState<any>(null);
  const [scoutOpen, setScoutOpen] = useState(false);

  useEffect(() => {
    if (!uuid) return;
    companyService.viewProfile(uuid)
      .then(setData)
      .catch((err) => setError(err.response?.data?.message || 'プロフィールの取得に失敗しました'))
      .finally(() => setLoading(false));
  }, [uuid]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
        <Button variant="outlined" onClick={() => navigate('/company/search')}>
          検索に戻る
        </Button>
      </Container>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      <Box sx={{ bgcolor: '#0066cc', color: 'white', py: 3 }}>
        <Container maxWidth="md">
          <Button startIcon={<ArrowBack />} onClick={() => navigate('/company/search')}
            sx={{ color: 'white', mb: 1 }}>
            検索結果に戻る
          </Button>
          <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' } }}>
            アスリートプロフィール
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.5, opacity: 0.9 }}>
            匿名プロフィール（個人情報は非表示です）
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="md" sx={{ py: 4 }}>
        {/* スカウト送信ボタン */}
        <Card sx={{ mb: 3, border: '1px solid #ff9800', bgcolor: '#fff8e1' }}>
          <CardContent sx={{ p: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                このアスリートにスカウトを送信
              </Typography>
              <Typography variant="body2" sx={{ color: '#666' }}>
                匿名のまま、メッセージを送ることができます
              </Typography>
            </Box>
            <Button
              variant="contained"
              startIcon={<Send />}
              onClick={() => setScoutOpen(true)}
              sx={{ bgcolor: '#ff9800', '&:hover': { bgcolor: '#f57c00' } }}
            >
              スカウトを送る
            </Button>
          </CardContent>
        </Card>

        <ProfileCard profile={data?.profile} showDualCareer={true} />

        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Button variant="outlined" onClick={() => navigate('/company/search')}>
            検索結果に戻る
          </Button>
        </Box>
      </Container>

      {/* スカウト送信ダイアログ */}
      <ScoutForm
        open={scoutOpen}
        onClose={() => setScoutOpen(false)}
        athleteUuid={uuid || ''}
        onSent={() => navigate('/company/scouts')}
      />
    </Box>
  );
};

export default ProfileDetailPage;
